import AppTour from '@components/tour/AppTour';
import { TOUR_ID } from '@components/tour/tours';

/**
 * `AppTour` as the new video project screen sees it, once a video is in.
 *
 * Mount it then only: the engine checks once, on mount, whether any step has something to point at, and the
 * fields it points at are on the screen once the video is read. It needs no stages — every step points at
 * something already there, and the trim step is dropped for a video the browser cannot play. Moving on to the
 * upload unmounts it.
 *
 * `suppressed` while the AI suggestion is still on its way: when it lands it fills in what to count, which
 * would change the form under an open tour.
 */
const NewVideoTour = ({ suppressed = false }) => (
	<AppTour tourId={TOUR_ID.VIDEO_NEW_PROJECT} suppressed={suppressed} />
);

export default NewVideoTour;
